// The no-thumbnail image is served as a static asset from the public/ directory.
// Using a URL reference instead of an inline base64 string keeps it out of the
// JavaScript bundle, reducing parse time and allowing the browser to cache it
// independently.
export const b64NoImage = "/no-thumbnail.jpg";
